import { jsx as _jsx } from "react/jsx-runtime";
var Star = function Star(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.5614 21.0007C17.4034 21.0007 17.2444 20.9637 17.0984 20.8877L11.9994 18.2237L6.90138 20.8877C6.56338 21.0627 6.15538 21.0327 5.84938 20.8087C5.54138 20.5847 5.38838 20.2057 5.45338 19.8307L6.42438 14.2027L2.30438 10.2177C2.03038 9.95272 1.93138 9.55472 2.04838 9.19072C2.16538 8.82872 2.47838 8.56372 2.85638 8.50972L8.55638 7.68172L11.1044 2.55572C11.4424 1.87572 12.5574 1.87572 12.8954 2.55572L15.4434 7.68172L21.1434 8.50972C21.5214 8.56372 21.8344 8.82872 21.9514 9.19072C22.0684 9.55472 21.9694 9.95272 21.6954 10.2177L17.5754 14.2027L18.5464 19.8307C18.6114 20.2057 18.4574 20.5847 18.1504 20.8087C17.9764 20.9367 17.7694 21.0007 17.5614 21.0007Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Star;